const CRITICAL_BORDER = 6;

export const isExpirationWarning = (remainingDays: number): boolean =>
  remainingDays < CRITICAL_BORDER;
